import addInfoBarMessage from '../actions/addInfoBarMessage';
import ComposeViewState from '../store/schema/ComposeViewState';
import getEncryptionInfoBarMessageId from './getEncryptionInfoBarMessageId';
import isEncryptionEnabled from 'owa-encryption-common/lib/utils/isEncryptionEnabled';

export default function addEncryptionInfobarFromIRMData(viewState: ComposeViewState) {
    const infobarIdForEncryption =
        isEncryptionEnabled() && viewState.IRMData
            ? getEncryptionInfoBarMessageId(viewState.IRMData.RmsTemplateId)
            : null;

    if (infobarIdForEncryption && viewState.infoBarIds.indexOf(infobarIdForEncryption) < 0) {
        addInfoBarMessage(viewState, infobarIdForEncryption);
    }
}
